import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { Store } from '@ngrx/store';

import { AppState } from '../../../../store/app-state';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent implements OnInit {

  @Input()
  data: string = null;

  @Input()
  size: number = 40;

  value$;

  constructor(private store: Store<AppState>) {
    this.value$ = this.store.select(state => state.user.isAuth ? state.user.data.email[0] : '' )
  }
  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/core/component/core/avatar/avatar.component.ts